import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/reports/@@individual.rpc`,
    services: {
        module_best: {
            parameters: [
                { name: 'member_id', type: 'string', optional: false },
                { name: 'product_id', type: 'string', optional: true },
                { name: 'session_id', type: 'integer', optional: true },
                { name: 'lp', type: 'string', optional: true },
                { name: 'site', type: 'string', optional: true },
                { name: 'select', type: 'object', optional: true }
            ]
        },
        attempts_quizzes: {
            parameters: [
                { name: 'quiz_type', type: 'string', optional: false },
                { name: 'member_id', type: 'string', optional: false },
                { name: 'product_id', type: 'string', optional: true },
                { name: 'session_id', type: 'integer', optional: true },
                { name: 'lp', type: 'string', optional: true },
                { name: 'site', type: 'string', optional: true },
                { name: 'select', type: 'object', optional: true }
            ]
        }
    }
});
export default svc;
